import React, { useEffect, useRef, useState } from 'react'

import { apiGet } from '../../generic/Api_Functions'
import { InputLabel, Select, FormControl, Chip, Grid, IconButton, MenuItem, Stack } from '@mui/material'
import { AddCircleRounded, DeleteRounded } from '@mui/icons-material'
import SensorsActuatorsComponentsFunctionsProtocols from './SensorsActuatorsComponentsFunctionsProtocols'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

const SensorsActuatorsComponentsFunctions = (props) => {
  const { ioElementSet, setIoElementSet, ioElementSetFunction, addNewFunction, setAddNewFunction, setSaveDisabled, editMode } = props
  const [functions, setFunctions] = useState([])
  const [addIoElementSetFunctionIoElement, setAddIoElementSetFunctionIoElement] = useState(false)
  const oldValue = useRef()
  const { t_ } = useSmartTranslation()

  useEffect(() => {
    const fetchData = async () => {
      const functionsDB = await apiGet('functions/ioElementSetType/' + ioElementSet.ioElementSetType.id)
      setFunctions(functionsDB)
    }

    fetchData()
  }, [ioElementSet])

  useEffect(() => {
    setSaveDisabled(addIoElementSetFunctionIoElement)
  }, [addIoElementSetFunctionIoElement, setSaveDisabled])

  const funcion = ioElementSetFunction !== undefined ? ioElementSetFunction.function : ''

  const handleValue = (value) => {
    if (functions.length === 0) return ''
    if (value !== undefined) {
      oldValue.current = value
      return value
    }
    if (ioElementSetFunction !== undefined) {
      oldValue.current = ioElementSetFunction.function.code
      return ioElementSetFunction.function.code
    }
    return ''
  }

  const getFunctionsToShow = () => {
    if (ioElementSetFunction === undefined && ioElementSet.ioElementSetFunctions.length !== 0) {
      // * Get all functions and remove used function's for this function
      return functions.filter((element) => !ioElementSet.ioElementSetFunctions.find(compare => compare.function.id === element.id))
    } else {
      const notUsedFunctions = functions.filter((element) => !ioElementSet.ioElementSetFunctions.find(compare => compare.function.id === element.id))
      const functionValue = ioElementSet.ioElementSetFunctions.find(compare => compare.function.code === handleValue())
      if (functionValue !== undefined) { notUsedFunctions.push(functionValue.function) }
      return notUsedFunctions
    }
  }

  const deleteFunction = () => {
    if (funcion === undefined) {
      setAddNewFunction(false)
    }
    const copyIoELementSet = { ...ioElementSet }
    copyIoELementSet.ioElementSetFunctions = ioElementSet.ioElementSetFunctions.filter((ioElementSetFunction) => {
      return (ioElementSetFunction.function.code !== funcion.code)
    })
    setIoElementSet(copyIoELementSet)
  }
  return (
    <>
      <Grid item xs={11}>
        <Grid container sx={{ border: addNewFunction ? '0.5px solid #7EE1A7' : '0.5px solid rgba(255, 255, 255, 0.12)', padding: '2em', borderRadius: '5px' }}>
          <Grid item xs={12} sx={{ paddingBottom: '2em', borderBottom: '0.5px solid rgba(255, 255, 255, 0.12)' }}>
            <Stack
              direction='row'
              justifyContent='space-between'
            >
              <Stack direction='row' spacing={4}>
                <FormControl variant='standard'>
                  <InputLabel id='function-label'>{t_('Function')}</InputLabel>
                  <Select
                    value={handleValue()}
                    disabled
                    // disabled={ioElementSetFunction !== undefined && ioElementSetFunction.function.code !== undefined && !editMode}
                    onChange={(event) => {
                      handleValue(event.target.value)
                      const ioElementSetFunctionNew = {
                        ioElementSet: {
                          id: ioElementSet.id,
                          code: ioElementSet.code,
                          name: ioElementSet.name
                        },
                        function: functions.find(functionObject => functionObject.code === event.target.value),
                        ioElementSetFunctionIoElements: []
                      }
                      ioElementSet.ioElementSetFunctions.unshift(ioElementSetFunctionNew)
                      setIoElementSet(ioElementSet)
                      setAddNewFunction(false)
                    }}
                    style={{ minWidth: '6em' }}
                  >
                    {getFunctionsToShow().map((functio) => (
                      <MenuItem value={functio.code} key={functio.code}>
                        {functio.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
              <Chip
                disabled
                // disabled={ioElementSetFunction !== undefined && ioElementSetFunction.function.code !== undefined && !editMode}
                icon={<AddCircleRounded />}
                label={t_('Add sensor/actuator')}
                onClick={() => setAddIoElementSetFunctionIoElement(prev => true)}
                sx={{ backgroundColor: (theme) => theme.palette.background.chip, margin: '1em' }}
              />
            </Stack>
          </Grid>
          {
            addIoElementSetFunctionIoElement
              ? <SensorsActuatorsComponentsFunctionsProtocols
                  ioElementSet={ioElementSet}
                  funcion={funcion}
                  setIoElementSet={setIoElementSet}
                  addIoElementSetFunctionIoElement={addIoElementSetFunctionIoElement}
                  setAddIoElementSetFunctionIoElement={setAddIoElementSetFunctionIoElement}
                  setSaveDisabled={setSaveDisabled}
                  editMode={editMode}
                />
              : null
          }
          {/* { //TODO: Refactor using simple endpoints
            ioElementSet.ioElementSetFunctions
              .sort((a, b) => a.id - b.id)
              .filter((ioElementSetFunctionH) => ioElementSetFunctionH.function.code === (funcion.code))
              .map((ioElementSetFunction) => (
                ioElementSetFunction.ioElementSetFunctionIoElements
                  .sort((a, b) => a.id - b.id)
                  .map((ioElementSetFunctionIoElement, index) => (
                    <SensorsActuatorsComponentsFunctionsProtocols
                      key={ioElementSetFunctionIoElement.ioElement.code.concat(index)}
                      ioElementSet={ioElementSet}
                      setIoElementSet={setIoElementSet}
                      funcion={ioElementSetFunction.function}
                      ioElementSetFunctionIoElement={ioElementSetFunctionIoElement}
                      setSaveDisabled={setSaveDisabled}
                      editMode={editMode}
                    />
                  ))))
          } */}
        </Grid>
      </Grid>
      <Grid item xs={1}>
        <IconButton
          // style={{ color: editMode ? 'white' : 'gray' }}
          onClick={() => deleteFunction()}
          disabled
          // disabled={!editMode}
        >
          <DeleteRounded />
        </IconButton>
      </Grid>
    </>
  )
}

export default SensorsActuatorsComponentsFunctions
